module.exports = __webpack_public_path__ + "img/site.981b2e36.png";